import Grid from '@mui/material/Grid2';
import { Control } from 'react-hook-form';
import { MdContentCopy } from 'react-icons/md';

import Button from '@/components/Common/Button';
import Search from '@/components/Common/Search';
import Select from '@/components/Common/Select';
import {
  BUSINESS_STATE_FILTER_OPTIONS,
  OnboardingListFormValues,
  SOURCE_FILTER_OPTIONS,
  STATUS_FILTER_OPTIONS
} from '../constants';

interface OnboardingFiltersProps {
  control: Control<OnboardingListFormValues>;
  searchText: string | null;
  setSearchText: (value: string | null) => void;
  onCopyLink: () => void;
}

const selectSx = {
  background: '#fff',
  '& .MuiOutlinedInput-root': { borderRadius: '10px' }
};

export default function OnboardingFilters({ control, searchText, setSearchText, onCopyLink }: OnboardingFiltersProps) {
  return (
    <Grid container spacing={2} mb={2} alignItems='flex-end'>
      <Grid size={2.5} mb={0.5}>
        <Search
          placeholder='Search businesses'
          searchText={searchText}
          setSearchText={setSearchText}
          size='small'
          fullWidth
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px'
            }
          }}
        />
      </Grid>

      <Grid size={2}>
        <Select
          name='status'
          label='Status'
          control={control}
          sortOrder='none'
          size='small'
          fullWidth
          options={STATUS_FILTER_OPTIONS}
          sx={selectSx}
        />
      </Grid>

      <Grid size={2}>
        <Select
          name='source'
          label='Source'
          control={control}
          size='small'
          fullWidth
          options={SOURCE_FILTER_OPTIONS}
          sx={selectSx}
        />
      </Grid>

      <Grid size={2}>
        <Select
          name='business_state'
          label='Business State'
          control={control}
          sortOrder='none'
          size='small'
          fullWidth
          options={BUSINESS_STATE_FILTER_OPTIONS}
          sx={selectSx}
        />
      </Grid>

      <Grid size={3.5} mb={0.5}>
        <Button fullWidth sx={{ height: 40, whiteSpace: 'nowrap' }} startIcon={<MdContentCopy />} onClick={onCopyLink}>
          Copy Onboarding Link
        </Button>
      </Grid>
    </Grid>
  );
}
